import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import ExpenseTableRow from "../components/daily-expenses/expenseTableRow";
import ExpenseToolBar from "../components/daily-expenses/expensesToolBar";
import { get_daily_expense } from "../features/expense/expensesService";

const ExpenseDaily = () => {
  const [formState, setFormState] = useState({
    dateFilterType: "single",
    selectedDate: new Date(),
    fromDate: "",
    toDate: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [reloadExpenses, setReloadExpenses] = useState(false);
  const [expData, setExpData] = useState<any[]>([]);
  const [filteredExpData, setFilteredExpData] = useState<any[]>([]);

  const [nameInput, setNameInput] = useState("");
  const [categoryInput, setCategoryInput] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Pagination states
  const [page, setPage] = useState(0); // 0-indexed frontend
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const pharmacy_id: any = JSON.parse(localStorage.getItem("pharmacyId") || "{}");

  const handleFilterSearch = () => {
    const filterdata = expData?.filter((item: any) => {
      const nameMatch = item?.name?.toLowerCase().startsWith(nameInput?.toLowerCase());
      const categoryMatch = item?.exp_category?.name
        ?.toLowerCase()
        .startsWith(categoryInput?.toLowerCase());

      let dateMatch = true;
      const itemDate = item?.expense_date;

      if (
        formState?.dateFilterType === "range" &&
        (formState?.fromDate || formState?.toDate)
      ) {
        const itemTime = new Date(itemDate).getTime();
        const fromTime = formState.fromDate
          ? new Date(formState.fromDate).getTime()
          : -Infinity;
        const toTime = formState.toDate
          ? new Date(new Date(formState.toDate).setHours(23, 59, 59, 999)).getTime()
          : Infinity;
        dateMatch = itemTime >= fromTime && itemTime <= toTime;
      } else if (formState?.dateFilterType === "single" && formState?.selectedDate) {
        const selected = new Date(formState.selectedDate);
        const selectedStart = new Date(selected.setHours(0, 0, 0, 0)).getTime();
        const selectedEnd = new Date(selected.setHours(23, 59, 59, 999)).getTime();
        const itemTime = new Date(itemDate).getTime();

        dateMatch = itemTime >= selectedStart && itemTime <= selectedEnd;
      }

      return nameMatch && categoryMatch && dateMatch;
    });

    setFilteredExpData(filterdata);
    setAnchorEl(null);
  };

  const getExpense = useCallback(async () => {
    try {
      setIsLoading(true);

      let fromDate = "";
      let toDate = "";

      if (formState.dateFilterType === "range") {
        fromDate = formState.fromDate;
        toDate = formState.toDate;
      } else if (formState.dateFilterType === "single" && formState.selectedDate) {
        fromDate = new Date(formState.selectedDate).toISOString().split("T")[0];
        toDate = ""; // only send if it's range
      }

      const res = await get_daily_expense(
        pharmacy_id,
        fromDate,
        toDate,
        rowsPerPage,
        page + 1
      );

      const data = res?.data?.expenses || [];
      const totalItems = res?.data?.pagination?.total || 0;

      const sortedData = [...data].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );

      setExpData(sortedData);
      setFilteredExpData(sortedData);
      setTotalCount(totalItems);
    } catch (error) {
      console.error("Error fetching daily expenses:", error);
    } finally {
      setIsLoading(false);
    }
  }, [pharmacy_id, formState, rowsPerPage, page]);

  // Re-fetch on reload or pagination
  useEffect(() => {
    getExpense();
  }, [reloadExpenses, getExpense]);

  // Filtering (name/category/date) based on user inputs
  // useEffect(() => {
  //   handleFilterSearch();
  // }, [formState, expData, nameInput, categoryInput]);

  // Clear filters when date or pagination state changes
  useEffect(() => {
    setNameInput("");
    setCategoryInput("");
  }, [
    formState.dateFilterType,
    formState.selectedDate,
    formState.fromDate,
    formState.toDate,
    page,
    rowsPerPage,
  ]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset page
  };

  return (
    <Box sx={{ flexGrow: 1, px: 1 }}>
      {/* <Box
        sx={{
          fontSize: "22px",
          lineHeight: "24px",
          fontWeight: 500,
          color: "#0B2238",
          paddingTop: "20px",
          paddingBottom: "15px",
        }}
      >
        Daily Expense
      </Box> */}

      <Box sx={{ bgcolor: "white", my: "1.2%", minHeight: "80vh", px: 2}}>
        <Box sx={{ mt: 3 }}>
          <ExpenseToolBar
            isLoading={isLoading}
            clinicId={1}
            setFormState={setFormState}
            formState={formState}
            setReloadExpenses={setReloadExpenses}
            setNameInput={setNameInput}
            setCategoryInput={setCategoryInput}
            handleFilterSearch={handleFilterSearch}
            categoryInput={categoryInput}
            nameInput={nameInput}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setFilteredExpData={setFilteredExpData}
            expenseData={filteredExpData}
            fetchFilteredData={(data) => setFilteredExpData(data)}
          />
        </Box>

        <ExpenseTableRow
          expData={filteredExpData}
          totalCount={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          setReloadExpenses={setReloadExpenses}
          isPagination = {true}
        />
      </Box>
    </Box>
  );
};

export default ExpenseDaily;
